/**
 * A replacement for Backbone.sync that calls all appropriate callbacks
 * but doesn't communicate with the server.
 *
 * Adapted from Backbone localStorage Adapter version 1.1.16
 * https://github.com/jeromegn/Backbone.localStorage
 */
import Backbone from 'backbone'

var store = {
	save: function() {
	},

	create: function(model) {
		return this.find(model)
	},

	update: function(model) {
		return this.find(model)
	},

	find: function(model) {
		// Backbone wants to get a JavaScript object back, not a model, so
		// just returns the properties
		return model.toJSON ? model.toJSON() : model
	},

	findAll: function() {
		throw new Error('findAll() not implemented for mock-sync')
	},

	destroy: function(model) {
		return model
	}
}

function sync (method, model, options) {
	var resp, errorMessage
	//If $ is having Deferred - use it.
	var syncDfd = Backbone.$ ?
		(Backbone.$.Deferred && Backbone.$.Deferred()) :
		(Backbone.Deferred && Backbone.Deferred())

	// Defer to nextTick to properly emulate an XHR
	process.nextTick(function () {
		try {
			switch (method) {
				case 'read':
					resp = model.id != undefined ? store.find(model) : store.findAll()
					break
				case 'create':
					resp = store.create(model)
					break
				case 'update':
					resp = store.update(model)
					break
				case 'delete':
					resp = store.destroy(model)
					break
			}

		} catch(error) {
			errorMessage = error.message
		}

		if (resp) {
			if (options && options.success) {
				options.success(resp)
			}
			if (syncDfd) {
				syncDfd.resolve(resp)
			}

		} else {
			errorMessage = errorMessage ? errorMessage : 'Record Not Found'

			if (options && options.error)
				options.error(errorMessage)

			if (syncDfd)
				syncDfd.reject(errorMessage)
		}

		// add compatibility with $.ajax
		// always execute callback for success and error
		if (options && options.complete) options.complete(resp)
	}.bind(this))

	return syncDfd && syncDfd.promise()
}

export default sync

sync.__filename__ = 'components/mock-sync.js'
